import { Card } from "antd";
import SiteLayout from "~/components/layout/SiteLayout";
import GroupViewCard from "~/components/groups/GroupViewCard";
import PostList from "~/components/post/PostList";

import Error from "~/pages/_error";
import { getGroup } from "~/services/groups";
import { fetchPostList } from "~/redux/actions/post";

import { getCookie } from "~/utils/cookie";

const GroupViewPage = ({ group, postList, sort }) => {
  if (!group) {
    return <Error statusCode={404} />
  }

  return (
    <SiteLayout
      pageTitle={group.name}
      pageSider={<GroupViewCard group={group} />}
      siderOptions={{ size: "md", position: "left" }}
    >
      <PostList postList={postList} sort={sort} />
    </SiteLayout>
  );
};

GroupViewPage.requireUser = () => false

GroupViewPage.getInitialProps = async (ctx) => {
  const { query } = ctx;

  try {
    const group = await getGroup(ctx.query.id);
    
    // 加载群组帖子列表
    const cookieSort = getCookie("sort", ctx.req);
    const sort = query.sort || cookieSort;
    const page = parseInt(query.page) || 1;
    const postList = await fetchPostList({ sort, page, group_id: group.id });

    return { group, postList, page, sort };
  } catch (error) {
    ctx.res.statusCode = 404;
    return {};
  }
};

export default GroupViewPage;
